import { ThemeDefinition } from 'vuetify';

import { flatten } from '@silae/helpers';
import { SILAE_KIT_THEMES } from '@silae/styles';

const OVERRIDE_COLORS_LIGHT = {
	brand: {
		primary: '#056EA1',
		secondary: '#056EA1', // same as primary
		'primary-surface': '#edf3f6',
		'secondary-surface': '#f6f3ee',
		'decorative-blue': '#93C7FB',
		'on-decorative-blue': '#00468b',
		'on-primary': '#fff',
		selected: '#ECEFF0'
	},
	level: {
		error: '#FF0000',
		'error-background': '#FFE5E5',
		info: '#0051FF',
		'info-background': '#E5EEFF',
		neutral: '#595857',
		'neutral-background': '#F6F3EE',
		success: '#2E7D29',
		'success-background': '#EAF2E9',
		warning: '#f76707',
		'warning-background': '#fef0e6'
	}
};

const OVERRIDE_COLORS_DARK = {
	brand: {
		primary: '#61add7',
		secondary: '#61add7', // same as primary
		'primary-surface': '#2F3132',
		'secondary-surface': '#4A4947',
		'decorative-blue': '#093867',
		'on-decorative-blue': '#7cbaf8',
		'on-primary': '#191d24',
		selected: '#ECEFF0'
	},
	level: {
		error: '#ff0000',
		'error-background': '#660000',
		info: '#80A9FF',
		'info-background': '#334466',
		neutral: '#C9C8C8',
		'neutral-background': '#656462',
		success: '#55D44D',
		'success-background': '#22551F',
		warning: '#F76707',
		'warning-background': '#632903'
	}
};

const light: ThemeDefinition = {
	colors: {
		...SILAE_KIT_THEMES.light,
		...flatten(OVERRIDE_COLORS_LIGHT)
	}
};

const dark: ThemeDefinition = {
	dark: true,
	colors: {
		...SILAE_KIT_THEMES.dark,
		...flatten(OVERRIDE_COLORS_DARK)
	}
};

export const vuetifyTheme = {
	themes: {
		dark,
		light
	}
};
